module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/5_0be571dc9b537a4cffa58bb209f8e683.png";